import { render } from "./AppSkeletonCase.vue?vue&type=template&id=1da07a1e&scoped=true&ts=true"
import script from "./AppSkeletonCase.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonCase.vue?vue&type=script&lang=ts"

import "./AppSkeletonCase.vue?vue&type=style&index=0&id=1da07a1e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da07a1e"]])

export default __exports__